import PropTypes from 'prop-types';
import Spinner from './Spinner.jsx'

const LoadingScreen = ({ title = 'Loading...', subtitle }) => {
  return (
    <div className="h-screen-mobile w-screen flex items-center justify-center bg-bg-page">
      <div className="flex flex-col items-center gap-spacing-2">
        <Spinner size="lg" color="text-accent" variant="ring" />
        <p className="text-primary text-dls-h2">{title}</p>
        {subtitle && <p className="text-secondary text-dls-body">{subtitle}</p>}
      </div>
    </div>
  )
}

LoadingScreen.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default LoadingScreen